import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PagesService {

  constructor() { }

  getPages() {
    return [
      {
        title: 'Inicio',
        url: '/tabs/inicio',
        icon: 'home'
      },
      /*{
        title: 'Artículos',
        url: '/tabs/products',
        icon: 'basket'
      },*/
      {
        title: 'Categorías',
        url: '/tabs/category',
        icon: 'md-grid'
      },
      {
        title: 'Chat',
        url: '/tabs/mensajes',
        icon: 'chatboxes'
      },
      {
        title: 'Favoritos',
        url: '/tabs/favoritos',
        icon: 'heart'
      },
      {
        title: 'Histórico',
        url: '/tabs/historico',
        icon: 'time'
      },
      {
        title: 'Mi cuenta',
        url: '/tabs/tab5',
        icon: 'person'
      },      
      {
        title: 'Cerrar sesión',
        action: 'logout',
        icon: 'log-out'
      }/*,
      {
        title: 'Pedidos',
        url: '/tabs/orders',
        icon: 'md-checkmark-circle-outline'
      }*/
    ];
  }
}
